import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import { AuthHelpers } from '../api/auth.js'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import(/* webpackChunkName: "dashboard" */ '../views/Dashboard.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/registrations',
    name: 'registrations',
    component: () => import(/* webpackChunkName: "registrations" */ '../views/Registrations.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/registrations/create',
    name: 'registration-create',
    component: () => import(/* webpackChunkName: "registration-create" */ '../views/RegistrationCreate.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/registrations/:id',
    name: 'registration-detail',
    component: () => import(/* webpackChunkName: "registration-detail" */ '../views/RegistrationDetail.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/attendance',
    name: 'attendance',
    component: () => import(/* webpackChunkName: "attendance" */ '../views/Attendance.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/special-guests',
    name: 'special-guests',
    component: () => import(/* webpackChunkName: "special-guests" */ '../views/SpecialGuests.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/sponsorships',
    name: 'sponsorships',
    component: () => import(/* webpackChunkName: "sponsorships" */ '../views/Sponsorships.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/users',
    name: 'users',
    component: () => import(/* webpackChunkName: "users" */ '../views/Users.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import(/* webpackChunkName: "profile" */ '../views/Profile.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Navigation guards for authentication
router.beforeEach((to, from, next) => {
  const isAuthenticated = AuthHelpers.isAuthenticated()

  // If route requires auth and user is not authenticated, redirect to login
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      next({ name: 'home' })
      return
    }
  }

  // If user is authenticated and tries to access login page, redirect to dashboard
  if (to.name === 'home' && isAuthenticated) {
    next({ name: 'dashboard' })
    return
  }

  next()
})

export default router
